<mat-dialog-content class="dialog-content">
  @if (isUserTeamAdmin) {
    <div class="layout field-container">
      <div class="field-selection">
        <mat-label>Customer name</mat-label>
        <mat-form-field appearance="outline">
          <input [formControl]="customerName" matInput placeholder="Enter your customer" type="text" />
        </mat-form-field>
      </div>
      <mds-button
        [size]="'medium'"
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [isIconLeft]="false"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
        (click)="updateCustomerName()"
        [disabled]="!customerName.getRawValue()"
        role="button"
      >
        Update
      </mds-button>
    </div>
  }
  @if (showDefaultCompany) {
    <div class="layout field-container">
      @if (!isCompanySelected) {
        <div class="field-selection">
          <mat-label>Default Company for Hotspots dashboard</mat-label>
          <mat-form-field appearance="outline">
            <div class="section company-container">
              <input
                #autocompleteInput
                (focus)="addPanelListener()"
                [formControl]="companyControl"
                [matAutocomplete]="companyAutocomplete"
                [ngStyle]="{ display: isCompanySelected ? 'none' : 'inline-block' }"
                aria-label="Select Company"
                class="updateManual"
                matInput
                type="text"
              />
              <mat-autocomplete
                #companyAutocomplete="matAutocomplete"
                [displayWith]="displayWithFn"
                class="company-panel"
              >
                @for (company of suggestions; track company) {
                  <mat-option class="company-options" [value]="company">
                    @if (company.type !== 'create new') {
                      <div>
                        <mds-object-card [compact]="false" [data]="company"></mds-object-card>
                      </div>
                    }
                  </mat-option>
                }
                @if (isLoading) {
                  <mat-option class="company-option loading-more" disabled>Loading more...</mat-option>
                }
              </mat-autocomplete>
            </div>
          </mat-form-field>
        </div>
      }
      @if (isCompanySelected) {
        <div>
          <mat-label class="mb-8">Default Company for Hotspots dashboard</mat-label>
          <mds-object-card
            (actionClick)="removeTile(); $event.stopPropagation()"
            [actionIcon]="icons.REMOVE"
            [compact]="true"
            [data]="companyControl?.value"
            [menu]="[]"
          ></mds-object-card>
        </div>
      }
      <mds-button
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [isIconLeft]="false"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
        (click)="updateCompany()"
        aria-label="Update Company"
        role="button"
      >
        Update
      </mds-button>
    </div>
  }

  @if (showScipRsl) {
    <div class="layout field-container">
      @if (!isScipRslSelected) {
        <div class="field-selection">
          <mat-label>{{ showScipRsl.description }}</mat-label>
          <mat-form-field appearance="outline">
            <div class="section">
              <input
                #autocompleteInput
                (focus)="addPanelListener()"
                [formControl]="scipRslControl"
                [matAutocomplete]="autocomplete"
                [ngStyle]="{ display: isScipRslSelected ? 'none' : 'inline-block' }"
                [attr.aria-label]="showScipRsl.title"
                class="updateManual"
                matInput
                type="text"
              />
              <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayWithFn">
                @for (rslList of scipRslList; track rslList) {
                  <mat-option class="company-options" [value]="rslList">
                    <mds-object-card [compact]="false" [data]="rslList"></mds-object-card>
                  </mat-option>
                }
                @if (isLoading) {
                  <mat-option class="company-option loading-more" disabled>Loading more...</mat-option>
                }
              </mat-autocomplete>
            </div>
          </mat-form-field>
        </div>
      }
      @if (isScipRslSelected) {
        <div>
          <mat-label class="mb-8">{{ showScipRsl.description }}</mat-label>
          <mds-object-card
            (actionClick)="scipRslControl?.setValue(null); $event.stopPropagation()"
            [actionIcon]="icons.REMOVE"
            [compact]="true"
            [data]="scipRslControl?.value"
            [menu]="[]"
          ></mds-object-card>
        </div>
      }
      <mds-button
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [isIconLeft]="false"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
        (click)="updateValue(scipRslControl, showScipRsl)"
        aria-label="Update Value"
        role="button"
      >
        Update
      </mds-button>
    </div>
  }

  @if (companyLogoFormSchema) {
    <div class="layout field-container extra-margin" style="align-items: end">
      <div class="field-selection">
        <mat-label>{{ companyLogoFormSchema.title }}</mat-label>
        @if ((companyLogoFormSchema.defaultValue && companyLogoFormSchema.defaultValue != '') || selectedFile) {
          <div class="company-logo-container">
            <img
              [src]="companyLogoFormSchema.defaultValue || previewFile"
              alt="company logo"
              height="90"
              class="company-logo"
            />
            <div class="company-logo-actions">
              @if (selectedFile) {
                <mds-button
                  [size]="'small'"
                  [icon]="icons.UPLOAD"
                  [isIconLeft]="true"
                  [type]="'secondary'"
                  [iconPathColors]="['#547080']"
                  (click)="uploadCompanyLogo()"
                  aria-label="Upload Company Logo"
                  role="button"
                >
                  Upload image
                </mds-button>
              }
              <input #fileInput1 (change)="onCompanyLogoSelected($event)" id="fileInput1" type="file" hidden />
              @if (!selectedFile) {
                <mds-button
                  [size]="'small'"
                  [icon]="icons.RELOAD"
                  [isIconLeft]="true"
                  [type]="'secondary'"
                  [iconPathColors]="['#547080']"
                  (click)="openFilePicker1()"
                  aria-label="Upload Company Logo"
                  role="button"
                >
                  Replace image
                </mds-button>
              }
              <mds-button
                [size]="'small'"
                [icon]="icons.PROFILE_TRASH"
                [isIconLeft]="true"
                [type]="'tertiary'"
                [iconPathColors]="['#547080']"
                (click)="companyLogoFormSchema.defaultValue ? deleteCompanyLogo() : removeLocalFile()"
                aria-label="Upload Company Logo"
                role="button"
              >
                Remove image
              </mds-button>
            </div>
          </div>
        } @else {
          <input #fileInput (change)="onCompanyLogoSelected($event)" id="fileInput" type="file" hidden />
          <mds-button
            [size]="'small'"
            [icon]="icons.UPLOAD"
            [isIconRight]="true"
            [isIconLeft]="false"
            [type]="'secondary'"
            [iconPathColors]="['#547080']"
            (click)="openFilePicker()"
            aria-label="Upload Company Logo"
            role="button"
          >
            Choose image
          </mds-button>
        }
      </div>
    </div>
  }
  <div class="layout field-container">
    <div class="field-selection">
      <mat-label>Inline manual URL</mat-label>
      <mat-form-field appearance="outline">
        <input [(ngModel)]="inlineManual" matInput placeholder="Enter manual URL " type="text" />
      </mat-form-field>
    </div>
    <mds-button
      [size]="'small'"
      [icon]="icons.RECALCULATE"
      [isIconRight]="true"
      [isIconLeft]="false"
      [type]="'secondary'"
      [iconPathColors]="['#547080']"
      (click)="updateInlineJS()"
      [disabled]="!inlineManual"
      aria-label="Update"
      role="button"
    >
      Update
    </mds-button>
  </div>
  <div class="layout field-container">
    <div class="field-selection">
      <mat-label>Azure connection string</mat-label>
      <mat-form-field appearance="outline">
        <input [(ngModel)]="azureInformation" matInput placeholder="Enter azure connection string" type="text" />
      </mat-form-field>
    </div>
    <mds-button
      [size]="'small'"
      [icon]="icons.RECALCULATE"
      [isIconRight]="true"
      [isIconLeft]="false"
      [type]="'secondary'"
      [iconPathColors]="['#547080']"
      (click)="updateAzureInformation()"
      [disabled]="!azureInformation"
      role="button"
    >
      Update
    </mds-button>
  </div>

  @if (showUserShareImport) {
    <section class="layout field-container">
      <div class="field-selection">
        <mat-label>{{ showUserShareImport.title }}</mat-label>
        @if (isUserSelected) {
          <div class="remove-tile card-extra-setting">
            <button
              class="close-button"
              tabindex="0"
              (click)="removeUserTile(); $event.stopPropagation()"
              role="button"
              aria-label="Remove"
            >
              <mat-icon aria-hidden="true" class="close-icon">close</mat-icon>
            </button>
            <div class="user">
              <mds-avatar
                class="user__image"
                [altText]="'User avatar'"
                [firstName]="userControl?.value.firstname | getInitials: 'first'"
                [imageSrc]="userControl?.value.avatar"
                [lastName]="userControl?.value.lastname | getInitials: 'last'"
              ></mds-avatar>
              <div class="user__info">
                <h5>{{ userControl?.value.firstname }} {{ userControl?.value.lastname }}</h5>
                <div class="user__email">
                  {{ userControl?.value.email }}
                </div>
              </div>
            </div>
          </div>
        }
        @if (!isUserSelected) {
          <mat-form-field appearance="outline">
            <input
              class="updateManual"
              type="text"
              aria-label="Select User"
              matInput
              [formControl]="userControl"
              #autocompleteInput
              [matAutocomplete]="userAutocomplete"
              (focus)="onPanelFocus()"
              [ngStyle]="{
                display: isUserSelected ? 'none' : 'inline-block'
              }"
            />
          </mat-form-field>
        }
        <mat-autocomplete #userAutocomplete="matAutocomplete" [displayWith]="displayWithFn">
          @for (user of optionsList; track user) {
            <mat-option class="user-option" [value]="user">
              <div>
                <mds-object-card [compact]="true" [fullwidth]="true" [data]="user" [menu]="[]"></mds-object-card>
              </div>
            </mat-option>
          }
          @if (isLoading) {
            <mat-option class="user-option loading-more" disabled>Loading more...</mat-option>
          }
        </mat-autocomplete>
      </div>
      <mds-button
        [size]="'small'"
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
        (click)="updateUser()"
        role="button"
      >
        Update
      </mds-button>
    </section>
  }
  @if (
    isUserTeamAdmin &&
    (genericAiFormSchema ||
      alternativeAiFormSchema ||
      auxiliariesAiFormSchema ||
      aiExiobasePredictions ||
      eClassAiFormSchema)
  ) {
    <section class="radio-section">
      <h2 class="radio-section__title">General AI Enrichment</h2>

      <div class="radio-section__content">
        @if (genericAiFormSchema) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">{{ genericAiFormSchema.title }}</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                {{ genericAiFormSchema.description }}
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [formControl]="genericAiFormControl"
                    [ariaLabel]="genericAiFormSchema.title"
                    tabindex="0"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
            <div class="radio-section__subsection">
              <div class="radio-section__select-section">
                <div>
                  <h2 class="radio-section__subtitle">Prediction Model</h2>
                  <div class="radio-section__data">
                    <mat-label class="radio-section__description">Select Prediction Model</mat-label>
                  </div>
                </div>
                <div class="radio-section__select">
                  <mat-form-field appearance="outline">
                    <mat-select class="full-width" [formControl]="predictionModelValue">
                      @for (option of predictionModelOptions; track option.value) {
                        <mat-option [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="radio-section__select-section">
                <div>
                  <h2 class="radio-section__subtitle">Minimum Confidence Score</h2>
                  <mat-label class="radio-section__description">
                    Predictions Below this score will not be applied
                  </mat-label>
                </div>
                <mat-form-field class="radio-section__select" appearance="outline">
                  <input aria-label="Enter confidence score" [formControl]="confidenceScore" matInput type="number" />
                  <span class="radio-section__suffix" matSuffix>%</span>
                  @if (confidenceScore.hasError('required') && confidenceScore.touched) {
                    <mat-error>Minimum Confidence Score is required</mat-error>
                  }
                  @if (confidenceScore.hasError('min') && confidenceScore.touched) {
                    <mat-error>Minimum Confidence Score can't be less than 0</mat-error>
                  }
                  @if (confidenceScore.hasError('max') && confidenceScore.touched) {
                    <mat-error>Maximum Confidence Score can't be more than 100</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        }
        @if (alternativeAiFormSchema) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">{{ alternativeAiFormSchema.title }}</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                {{ alternativeAiFormSchema.description }}
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [formControl]="alternativeAiFormControl"
                    [ariaLabel]="alternativeAiFormSchema.title"
                    tabindex="0"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
        @if (auxiliariesAiFormSchema) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">{{ auxiliariesAiFormSchema.title }}</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                {{ auxiliariesAiFormSchema.description }}
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [formControl]="auxiliariesAiFormControl"
                    [ariaLabel]="auxiliariesAiFormSchema.title"
                    tabindex="0"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
        @if (aiExiobasePredictions) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">{{ aiExiobasePredictions.title }}</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                {{ aiExiobasePredictions.description }}
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [ariaLabel]="aiExiobasePredictions.title"
                    tabindex="0"
                    [formControl]="aiExiobasePredictionsControl"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
        @if (eClassAiFormSchema) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">{{ eClassAiFormSchema.title }}</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                {{ eClassAiFormSchema.description }}
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [ariaLabel]="eClassAiFormSchema.title"
                    tabindex="0"
                    [formControl]="eClassAiFormControl"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  }

  <div class="h-bar"></div>

  @if (isUserTeamAdmin && (closestMatchEnrichmentForm || ipcScrapingEnableForm || ipcLiveFeedComplianceForm)) {
    <section class="radio-section radio-section--extra-margin">
      <h2 class="radio-section__title">Electronic Component Enrichment</h2>

      <div class="radio-section__content">
        @if (ipcScrapingEnableForm) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">IPC live feed</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                Find Data of Components using a
                <b class="radio-section__highlight">direct MPN match</b>
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle [formControl]="isIpcScrapingEnable" aria-label="IPC live feed" tabindex="0">
                    {{ isIpcScrapingEnable?.value ? 'Enabled' : 'Disabled' }}
                  </mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
        @if (ipcLiveFeedComplianceForm) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">{{ ipcLiveFeedComplianceForm.title }}</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                {{ ipcLiveFeedComplianceForm.description }}
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [ariaLabel]="ipcLiveFeedComplianceForm.title"
                    tabindex="0"
                    [(ngModel)]="isIPCLiveFeedCompliance"
                    (onToggleChange)="toggle(ipcLiveFeedComplianceForm.key, $event)"
                  >
                    {{ isIPCLiveFeedCompliance ? 'Enabled' : 'Disabled' }}
                  </mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
        @if (closestMatchEnrichmentForm) {
          <div class="radio-section__group">
            <h2 class="radio-section__subtitle">Closest Match Enrichment</h2>
            <div class="radio-section__data">
              <mat-label class="radio-section__description">
                Find Data For Components with similar technical characteristics
              </mat-label>
              <div class="radio-section__form-wrapper container-alignment">
                <div class="radio-section__toggle-container">
                  <mds-slide-toggle
                    [formControl]="closestMatchEnrichment"
                    aria-label="Closest Match Enrichment"
                    tabindex="0"
                  >
                    {{ isIpcScrapingEnable ? 'Enabled' : 'Disabled' }}
                  </mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  }
  @if (isUserTeamAdmin && chemicalAIForPredictions) {
    <div class="h-bar"></div>
    <section class="field-section">
      <h2 class="item-header">Chemical Enrichment</h2>
      <div class="item-description">
        <div class="item-description__content">
          <h2 class="item-title">{{ chemicalAIForPredictions.title }}</h2>
          <mat-label class="item-subtitle">{{ chemicalAIForPredictions.description }}</mat-label>
        </div>
        <mds-slide-toggle
          [attr.aria-label]="chemicalAIForPredictions.title"
          [formControl]="chemicalAIForPredictionsForm"
        >
          {{ chemicalAIForPredictions.title }}
        </mds-slide-toggle>
      </div>
    </section>
  }
  @if (isUserTeamAdmin && limitPartPredictionFormSchema) {
    <div class="h-bar"></div>
    <section class="field-section">
      <h2 class="item-header">IMDS Import Enrichment</h2>
      <div class="item-description">
        <div class="item-description__content">
          <h2 class="item-title">{{ limitPartPredictionFormSchema.title }}</h2>
          <mat-label class="item-subtitle">{{ limitPartPredictionFormSchema.description }}</mat-label>
        </div>
        <mds-slide-toggle
          [ariaLabel]="limitPartPredictionFormSchema.title"
          [formControl]="limitPartPrediction"
          tabindex="0"
        >
          {{ limitPartPredictionFormSchema.title }}
        </mds-slide-toggle>
      </div>
    </section>
  }
  @if (isUserTeamAdmin && (excludePrivateDataFormSchema || excludePrivateAndPublicDataFormSchema)) {
    <div class="h-bar"></div>
    <section class="electronic-component">
      <h2 class="electronic-component__title">Name Based Default Alternative</h2>
      <mat-label class="electronic-component__title-description">
        Configure which data types are allowed to be automatically assigned as default alternatives when a name match is
        found
      </mat-label>
      <div class="electronic-component__content">
        @if (excludePrivateDataFormSchema) {
          <div class="electronic-component__section">
            <h2 class="electronic-component__subtitle">{{ excludePrivateDataFormSchema.title }}</h2>
            <div class="electronic-component__data">
              <mat-label class="electronic-component__description">
                {{ excludePrivateDataFormSchema.description }}
              </mat-label>
              <div class="electronic-component__form-wrapper container-alignment">
                <div class="electronic-component__form-container">
                  <mds-slide-toggle
                    [formControl]="excludePrivateDataFormControl"
                    [ariaLabel]="excludePrivateDataFormSchema.title"
                    tabindex="0"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
        @if (excludePrivateAndPublicDataFormSchema) {
          <div class="electronic-component__section">
            <h2 class="electronic-component__subtitle">{{ excludePrivateAndPublicDataFormSchema.title }}</h2>
            <div class="electronic-component__data">
              <mat-label class="electronic-component__description">
                {{ excludePrivateAndPublicDataFormSchema.description }}
              </mat-label>
              <div class="electronic-component__form-wrapper container-alignment">
                <div class="electronic-component__form-container">
                  <mds-slide-toggle
                    [formControl]="excludePublicAndPremiumFormControl"
                    [ariaLabel]="excludePrivateAndPublicDataFormSchema.title"
                    tabindex="0"
                  ></mds-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  }

  @if (isUserTeamAdmin && enablePrimaryDataOverwriteForm) {
    <div class="h-bar"></div>
    <section class="radio-section radio-section--extra-margin">
      <div class="radio-section__content">
        <div class="radio-section__group">
          <h2 class="radio-section__subtitle">{{ enablePrimaryDataOverwriteForm.title }}</h2>
          <div class="radio-section__data">
            <mat-label class="radio-section__description">
              {{ enablePrimaryDataOverwriteForm.description }}
            </mat-label>
            <div class="radio-section__form-wrapper container-alignment">
              <div class="radio-section__toggle-container">
                <mds-slide-toggle
                  [formControl]="enablePrimaryDataOverwrite"
                  [aria-label]="enablePrimaryDataOverwriteForm.title"
                  tabindex="0"
                >
                  {{ enablePrimaryDataOverwrite?.value ? 'Enabled' : 'Disabled' }}
                </mds-slide-toggle>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  @if (isUserTeamAdmin && skipDefaultAlternativeSchema) {
    <div class="h-bar"></div>
    <div class="layout extra-margin">
      <mat-label>{{ skipDefaultAlternativeSchema.description }}</mat-label>
      <mds-slide-toggle [ariaLabel]="skipDefaultAlternativeSchema.title" [formControl]="skipDefaultAlternative">
        {{ skipDefaultAlternativeSchema.title }}
      </mds-slide-toggle>
    </div>
  }
  @if (isUserTeamAdmin && supplyChainAlternativesSchema) {
    <div class="layout extra-margin">
      <mat-label>{{ supplyChainAlternativesSchema.description }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="supplyChainAlternativesSchema.title"
        [formControl]="supplyChainAlternativesControl"
      >
        {{ supplyChainAlternativesSchema.title }}
      </mds-slide-toggle>
    </div>
  }
  @if (isUserTeamAdmin && skipAssigningDefaultRoutesSchema) {
    <section class="layout extra-margin">
      <mat-label>{{ skipAssigningDefaultRoutesSchema.description }}</mat-label>
      <mds-slide-toggle
        class="section-form-container__margin"
        [formControl]="skipAssigningDefaultRoutesForm"
        [ariaLabel]="skipAssigningDefaultRoutesSchema.title"
        color="primary"
      >
        {{ skipAssigningDefaultRoutesSchema.title }}
      </mds-slide-toggle>
    </section>
  }
  @if (isUserTeamAdmin && ecoDesignEnableForm) {
    <div class="layout extra-margin">
      <mat-label>Ecodesign: private products only</mat-label>
      <mds-slide-toggle
        (onToggleChange)="toggleEcodesignProducts($event)"
        [(ngModel)]="isEcodesignEnabled"
        ariaLabel="Ecodesign enable private products only"
        tabindex="0"
      >
        Remove public and premium products from replacement suggestions
      </mds-slide-toggle>
    </div>
  }
  @if (isUserTeamAdmin && octopartEnrichmentForm) {
    <section class="layout extra-margin">
      <mat-label>{{ octopartEnrichmentForm.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="octopartEnrichmentForm.title"
        tabindex="0"
        color="primary"
        [(ngModel)]="isOctopartEnrichEnabled"
        (onToggleChange)="toggle(octopartEnrichmentForm.key, $event)"
      >
        {{ octopartEnrichmentForm.description }}
      </mds-slide-toggle>
    </section>
  }
  @if (isUserTeamAdmin && downStreamComplianceForm) {
    <section class="layout extra-margin">
      <mat-label>{{ downStreamComplianceForm.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="downStreamComplianceForm.title"
        tabindex="0"
        color="primary"
        [(ngModel)]="isDownStreamEnabled"
        (onToggleChange)="toggle(downStreamComplianceForm.key, $event)"
      >
        {{ downStreamComplianceForm.description }}
      </mds-slide-toggle>
    </section>
  }
  @if (isUserTeamAdmin && includeWIAMProductForm) {
    <section class="layout extra-margin">
      <mat-label>{{ includeWIAMProductForm.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="includeWIAMProductForm.title"
        tabindex="0"
        color="primary"
        [(ngModel)]="includeWIAMProduct"
        (onToggleChange)="toggle(includeWIAMProductForm.key, $event)"
      >
        {{ includeWIAMProductForm.description }}
      </mds-slide-toggle>
    </section>
  }
  @if (isUserTeamAdmin && genericAiPredictAuxiliaries) {
    <div class="layout extra-margin">
      <mat-label>{{ genericAiPredictAuxiliaries.description }}</mat-label>
      <mds-slide-toggle [ariaLabel]="genericAiPredictAuxiliaries.title" [formControl]="genericAiPredictAuxiliariesForm">
        {{ genericAiPredictAuxiliaries.title }}
      </mds-slide-toggle>
    </div>
  }
  @if (isUserTeamAdmin && questionnaireAttachmentOptionalForm) {
    <section class="layout extra-margin">
      <mat-label>{{ questionnaireAttachmentOptionalForm.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="questionnaireAttachmentOptionalForm.title"
        tabindex="0"
        color="primary"
        [(ngModel)]="questionnaireAttachmentEnabled"
        (onToggleChange)="toggle(questionnaireAttachmentOptionalForm.key, $event)"
      >
        {{ questionnaireAttachmentOptionalForm.description }}
      </mds-slide-toggle>
    </section>
  }
  @if (isUserTeamAdmin && discreteAlternativesForm) {
    <section class="layout extra-margin">
      <mat-label>{{ discreteAlternativesForm.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="discreteAlternativesForm.title"
        tabindex="0"
        color="primary"
        [(ngModel)]="isDiscreteAlternativesEnabled"
        (onToggleChange)="toggle(discreteAlternativesForm.key, $event)"
      >
        {{ discreteAlternativesForm.description }}
      </mds-slide-toggle>
    </section>
  }
  @if (isUserTeamAdmin && pcfQuestionnairesSetting) {
    <div>
      <form [formGroup]="pcfQuestionnairesForm">
        <div class="layout field-container">
          <div class="field-selection pcf-container">
            <mat-label>{{ pcfQuestionnairesSetting.title }}</mat-label>
            @for (item of pcfQuestionnairesEnum; track item) {
              <div class="flex-row">
                <mds-checkbox
                  [formControl]="pcfQuestionnairesForm.get(item.value)?.get('checkbox')"
                  [name]="item.name"
                ></mds-checkbox>
                <mat-label>{{ item.name }}</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select [formControl]="pcfQuestionnairesForm.get(item.value)?.get('dropdown')" class="full-width">
                    @for (order of pcfQuestionnairesOrder; track order) {
                      <mat-option [value]="order">
                        {{ order }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          </div>
          <mds-button
            [size]="'small'"
            (click)="submitPCFSection()"
            [icon]="icons.RECALCULATE"
            [isIconRight]="true"
            [isIconLeft]="false"
            [type]="'secondary'"
            [iconPathColors]="['#547080']"
            aria-label="Update"
            role="button"
          >
            Update
          </mds-button>
        </div>
      </form>
    </div>
  }
  @if (isUserTeamAdmin && currencyOptions?.length > 0) {
    <div class="layout field-container">
      <div class="field-selection">
        <mat-label>Preferred currency for team</mat-label>
        <mat-form-field appearance="outline">
          <input
            [formControl]="myControl"
            [matAutocomplete]="auto"
            aria-label="Select currency"
            matInput
            placeholder="Search preferred currency"
            type="text"
          />
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of filteredCurrency | async; track option) {
              <mat-option [attr.aria-label]="option.name" [value]="option.name" class="option-list" role="menuitem">
                {{ option.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <mds-button
        [size]="'small'"
        (click)="submitCurrency()"
        aria-label="Update"
        role="button"
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [isIconLeft]="false"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
      >
        Update
      </mds-button>
    </div>
  }
  @if (isUserTeamAdmin && projectManagerEmailSetting) {
    <div>
      <form (ngSubmit)="onSubmitEmailSetting()" [formGroup]="emailSettingForm" novalidate>
        <div class="layout field-container">
          <div class="field-selection">
            <mat-label>{{ projectManagerEmailSetting.title }}</mat-label>
            <mat-form-field appearance="outline">
              <input
                aria-label="Enter project manager email"
                formControlName="email"
                matInput
                placeholder="Enter project manager email"
                type="text"
              />
              @if (emailSettingForm.controls.email.hasError('required') && emailSettingForm.controls.email.touched) {
                <mat-error>Email field is required</mat-error>
              }
              @if (emailSettingForm.controls.email.hasError('pattern') && emailSettingForm.controls.email.touched) {
                <mat-error>Email must be a valid e-mail address</mat-error>
              }
            </mat-form-field>
          </div>
          <mds-button
            [size]="'small'"
            [disabled]="emailSettingForm.invalid"
            aria-label="Update"
            role="button"
            [icon]="icons.RECALCULATE"
            [isIconRight]="true"
            [isIconLeft]="false"
            [type]="'secondary'"
            [iconPathColors]="['#547080']"
          >
            Update
          </mds-button>
        </div>
      </form>
    </div>
  }
  @if (isUserTeamAdmin && customerTaxonomyFormSchema) {
    <div>
      <form [formGroup]="customerTaxonomyForm" (ngSubmit)="onSubmitCustomerTaxonomy()" novalidate>
        <div class="layout field-container">
          <div class="field-selection">
            <mat-label>{{ customerTaxonomyFormSchema?.title }}</mat-label>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [placeholder]="customerTaxonomyFormSchema?.title"
                [attr.aria-label]="customerTaxonomyFormSchema?.title"
                [formControlName]="customerTaxonomyFormSchema.key"
              />
            </mat-form-field>
          </div>
          <mds-button
            [size]="'small'"
            [disabled]="customerTaxonomyForm.invalid"
            aria-label="Submit"
            [type]="'secondary'"
          >
            Submit
          </mds-button>
        </div>
      </form>
    </div>
  }
  @if (isUserTeamAdmin && supplierDatasetSchema) {
    <div class="layout field-selection">
      <mat-label>{{ supplierDatasetSchema.title }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="selectedSupplierDataset" aria-label="select supplier dataset">
          @for (option of supplierDatasetSchema.enum; track option) {
            <mat-option [value]="option.value">
              {{ option.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  @if (isUserTeamAdmin && optOutOfUXTrackingFormSchema) {
    <div class="layout extra-margin">
      <mat-label>{{ optOutOfUXTrackingFormSchema.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="optOutOfUXTrackingFormSchema.title"
        [formControl]="isOptOutOfUXTrackingEnabledFormControl"
        tabindex="0"
      >
        {{ optOutOfUXTrackingFormSchema.description }}
      </mds-slide-toggle>
    </div>
  }

  @if (isUserTeamAdmin && rslFormSchema) {
    <div class="layout field-container">
      <div class="field-selection">
        <mat-label>{{ rslFormSchema.description }}</mat-label>
        <div
          mdsInlineFormSchema
          [lines]="rslFormLine ? [rslFormLine] : null"
          [schema]="{ formSchema: [rslFormSchema] }"
          (formValueChanged)="rslOnChanged($event)"
          style="width: 100%"
        ></div>
      </div>
      <mds-button
        [size]="'small'"
        (click)="updateRSL()"
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [isIconLeft]="false"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
        aria-label="Update"
        role="button"
        style="margin-top: auto; margin-bottom: 2.5rem"
      >
        Update
      </mds-button>
    </div>
  }

  @if (isUserTeamAdmin && scope3DashboardEnabledForm) {
    <section class="layout extra-margin">
      <mat-label>{{ scope3DashboardEnabledForm.title }}</mat-label>
      <mds-slide-toggle
        [ariaLabel]="scope3DashboardEnabledForm.title"
        tabindex="0"
        color="primary"
        [(ngModel)]="isScope3DashboardEnabled"
        (onToggleChange)="toggleScope3Dashboard($event)"
      >
        {{ scope3DashboardEnabledForm.description }}
      </mds-slide-toggle>
    </section>
  }

  @if (scope3UserSchema) {
    <div class="h-bar"></div>
    <section class="layout field-container">
      <div class="field-selection">
        <mat-label>{{ scope3UserSchema.description }}</mat-label>
        <div *ngIf="isScope3UserSelected" class="remove-tile card-extra-setting">
          <button
            class="close-button"
            tabindex="0"
            (click)="removeScope3UserTile(); $event.stopPropagation()"
            role="button"
            aria-label="Remove"
          >
            <mat-icon aria-hidden="true" class="close-icon">close</mat-icon>
          </button>

          <div class="user">
            <mds-avatar
              class="user__image"
              [altText]="'User avatar'"
              [firstname]="scope3UserControl?.value.firstname | getInitials: 'first'"
              [imageSrc]="scope3UserControl?.value.avatar"
              [lastname]="scope3UserControl?.value.lastname | getInitials: 'last'"
            ></mds-avatar>
            <div class="user__info">
              <h5>{{ scope3UserControl?.value.firstname }} {{ scope3UserControl?.value.lastname }}</h5>
              <div class="user__email">
                {{ scope3UserControl?.value.email }}
              </div>
            </div>
          </div>
        </div>
        <mat-form-field appearance="outline" *ngIf="!isScope3UserSelected">
          <input
            class="updateManual"
            type="text"
            aria-label="Select User"
            matInput
            [formControl]="scope3UserControl"
            #autocompleteInput
            [matAutocomplete]="scope3UserAutoComplete"
            (focus)="onPanelFocus()"
            [ngStyle]="{
              display: isScope3UserSelected ? 'none' : 'inline-block'
            }"
          />
        </mat-form-field>
        <mat-autocomplete #scope3UserAutoComplete="matAutocomplete" [displayWith]="displayWithFn">
          <mat-option class="user-option" *ngFor="let user of scope3UserOptions" [value]="user">
            <div>
              <mds-object-card [compact]="true" [fullwidth]="true" [data]="user" [menu]="[]"></mds-object-card>
            </div>
          </mat-option>
          <mat-option class="user-option loading-more" *ngIf="isLoading" disabled>Loading more...</mat-option>
        </mat-autocomplete>
      </div>
      <mds-button
        [size]="'small'"
        [icon]="icons.RECALCULATE"
        [isIconRight]="true"
        [type]="'secondary'"
        [iconPathColors]="['#547080']"
        (click)="updateScope3User()"
        role="button"
      >
        Update
      </mds-button>
    </section>
  }

  <div class="h-bar"></div>

  <div class="layout delete-team-container">
    <div class="delete-team-labels">
      <mat-label>Delete Team</mat-label>
      <mat-label style="width: 20rem">
        Running into any issues with your Makersite team site? Get in touch with support!
      </mat-label>
    </div>
    <mds-button
      [size]="'small'"
      [type]="'secondary'"
      [icon]="icons.CONTACT_SUPPORT"
      [isIconLeft]="true"
      (click)="contactSupport()"
      role="button"
    >
      Contact support
    </mds-button>
  </div>
  @if (isEditable) {
    <div>
      <p class="delete-confirmation">
        Still want to delete your team? Click on the button below.Keep in mind,
        <strong>deleting a team in non-reversible!</strong>
      </p>
      <mds-button
        [size]="'small'"
        (click)="deactiveTeam()"
        aria-label="Delete team"
        role="button"
        type="warn"
        [isIconLeft]="false"
        [isIconRight]="true"
        [iconRight]="icons.PROFILE_TRASH"
        [iconPathColors]="['#FFFFFF']"
      >
        Delete Team
      </mds-button>
    </div>
  }
</mat-dialog-content>
